export default "__VITE_ASSET__CRYeunSU__"